<template>
  <div class="filter input-group three-children">
    <input
      type="text"
      v-model="filter.name"
      placeholder="Filter Name"
    />
    <input
      type="text"
      v-model="filter.values"
      placeholder="Filter Values (comma separated)"
    />

    <div class="button-group">
      <Button
        :title="'Remove'"
        :type="'flat'"
        :colorTheme="'warning'"
        @button-click="$emit('delete-filter', filter)"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/components/form-elements/Button'

export default {
  name: 'ProjectFilterForm',
  props: ['filter'],
  components: {
    Button
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';

.filter {
  border-bottom: 1px solid $primary-shadow;
  margin-bottom: 16px;

  @media (min-width: 600px) {
    border-bottom: none;
  }
}

button {
  width: 100%;
}

.button-group {
  margin-top: 16px;

  @media (min-width: 600px) {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectFilterForm.vue